<!-- 购物车 预售车 公共基础部分 -->
<template>
  <div v-if="cartInfo" class="wrap">
    <div class="wrap-address" @click="toAddressList()">
      <div class="wrap-address-icon">
        <img :src="require('@/assets/img/address.png')" alt="">
      </div>
      <div class="wrap-address-info" v-if="getAddres && !Array.isArray(getAddres)">
        <p class="company">{{getAddres.title}}</p>
        <p class="contact">{{getAddres.contacter}}   {{getAddres.mobile}}</p>
        <p class="address">{{getAddres.address}}</p>
      </div>
      <div class="wrap-address-text" v-else>请选择地址</div>
      <div class="wrap-address-enter">
        <van-icon name="arrow" size="18px" />
      </div>
    </div>
    <div class="wrap-info">
      <van-cell-group :border="false">
        <van-cell
          v-if="isPresell"
          title-class="wrap-info-title"
          value-class="wrap-info-value"
          title="预售说明"
          value=""
          @click="isPresellPopup = true"
          is-link
        />
        <van-cell
          title-class="wrap-info-title"
          value-class="wrap-info-value"
          title="发票"
          :value="invoicesInfo"
          @click="openInvoicePopup"
          is-link
        />
        <van-cell
          title-class="wrap-info-title"
          value-class="wrap-info-value"
          title="优惠券"
          v-if="coupons && !isPresell"
          :value="couponText"
          @click="$emit('update:isCouponPopup',true)"
          is-link
        />
        <div class="integral" v-if="!isPresell && +cartInfo.is_show_valid_points">
          <span>可用{{cartInfo.valid_points}}积分抵现</span>
          <van-switch
            :active-color="theme['APP_theme_color']"
            v-model="cartInfo.points_open"
            size="20px"
          />
        </div>
        <div class="remark" @click="openRemarkPopup"><div>备注</div> <p class="remark-content" placeholder="请输入您要跟开单员说的话">{{remark}}</p></div>
      </van-cell-group>
    </div>
    <!-- 备注弹窗 -->
    <cc-bottom-popup
      title="备注"
      height="5.56rem"
      :autoHeight="true"
      getContainer='body'
      @close="isRemarkPopup = false"
      @subBtn="remarkHandler"
      :isShowPopup="isRemarkPopup">
      <div class="remark-popup">
        <textarea
          v-blurScroll
          class="remark-popup-content"
          placeholder="请输入你要对开单员说的话..."
          v-model="remarkConetnt"
          @input="remarkInput"
        >
        </textarea>
        <span class="remark-count">{{countLimit || '200/200'}}</span>
      </div>
    </cc-bottom-popup>
    <!-- 发票弹窗 -->
    <cc-bottom-popup
      title="发票"
      getContainer='body'
      :height="556"
      v-blurScroll
      :autoHeight="true"
      @close="isInvoicePopup = false"
      :isShowPopup="isInvoicePopup"
      @subBtn="postInvoice"
      v-if="cartInfo"
      >
      <div class="invoice-popup">
        <p class="invoice-title">发票类型</p>
        <ul class="invoice-type">
          <li class="invoice-type-item"
          :class="{'active':index === activeIndex}"
          v-for="(item,index) in ['不开发票','普通发票','增值税专用发票']"
          @click="activeIndex = index"
          :key="index">
          {{item}}
          </li>
        </ul>
        <div class="invoice-form" v-if="activeIndex">
          <van-field label="公司名称" required v-model="cartInfo.invoices.company_name" placeholder="请填写公司名称" />
          <van-field label="纳税人识别号" required v-model="cartInfo.invoices.taxpayer_number" placeholder="请填写纳税人识别号" />
          <template v-if="activeIndex === 2">
            <van-field label="注册地址" required v-model="cartInfo.invoices.taxpayer_regisaddress" placeholder="请填写注册地址" />
            <van-field label="注册电话" required v-model="cartInfo.invoices.tel" placeholder="请填写注册电话" />
            <van-field label="开户银行" required v-model="cartInfo.invoices.deposit_bank" placeholder="请填写开户银行" />
            <van-field label="银行账号" required v-model="cartInfo.invoices.bank_account" placeholder="请填写银行账号" />
          </template>
        </div>
      </div>
    </cc-bottom-popup>
    <!-- 优惠券弹窗 -->
    <cc-bottom-popup
      title="优惠券"
      getContainer='body'
      :height="556"
      @close="$emit('update:isCouponPopup',false)"
      @subBtn="$emit('update:isCouponPopup',false)"
      :isShowPopup="isCouponPopup"
      v-if="coupons"
      >
      <div class="coupon-popup">
        <ul class="coupon-type">
            <li
            class="coupon-type-item"
            :class="{active:couponActiveIndex === 'usable'}"
            @click="couponActiveIndex = 'usable'">{{`可用优惠券(${coupons.usable.length})`}}</li>
          <li
          class="coupon-type-item"
          :class="{active:couponActiveIndex === 'unusable'}"
          @click="couponActiveIndex = 'unusable'">{{`不可用优惠券(${coupons.unusable.length})`}}</li>
        </ul>
        <ul class="coupon-list">
          <li class="coupon-list-item" @click="selectCoupon(coupons)" :key="index" v-for="(coupons,index) in coupons[couponActiveIndex]">
            <div class="coupon-list-item-left"
            :style="{
              backgroundImage:getCouponImg(coupons)
            }">
                <p class="money mt20" v-if="+coupons.coupon_type === 1">￥<b>{{coupons.reduce_money}}</b></p>
                <p class="money mt20" v-else><b>{{coupons.discount}}折</b></p>
                <p v-if="coupons.full_amount === '0.00'">无门槛使用</p>
                <p v-else>满{{coupons.full_amount}}可用</p>
            </div>
            <div class="coupon-list-item-right">
                <div class="coupon-info">
                  <p class="coupon-info-name">{{coupons.tips}}</p>
                  <p class="coupon-info-time">{{coupons.start_time}}-{{coupons.end_time}}</p>
                </div>
                <van-checkbox
                  v-model="coupons.isSelect"
                  v-if="+coupons.state >= 2"
                  style="pointer-events:none"
                  :checked-color="theme['APP_theme_color']">
                </van-checkbox>
            </div>
          </li>
        </ul>
      </div>
    </cc-bottom-popup>
    <!-- 预售说明弹窗 -->
    <presell-explain :isShowPopup="isPresellPopup" @close="isPresellPopup=false">
    </presell-explain>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  loadCartIndex,
  postInvoice
} from '@/fetch/shopping-cart/purchase'
import presellExplain from './presell-explain.vue'
import { mapGetters, mapActions } from 'vuex'
import { wordCountLimit, SessionStorage } from '@/utils'
import { ResultCode } from '~const/ResultCode'
import { getTheme } from '@/assets/styles/theme.js'
import {
  Cell,
  CellGroup,
  Icon,
  Checkbox,
  Switch,
  AddressList,
  Field,
  Toast,
  PullRefresh,
  Popup,
  Dialog } from 'vant'
Vue.use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Checkbox)
  .use(Switch)
  .use(AddressList)
  .use(Field)
  .use(Toast)
  .use(PullRefresh)
  .use(Dialog)
  .use(Popup)
const invoiceType = {
  1: 2,
  2: 1
}
export default {
  name: 'base-common',
  components: {
    presellExplain
  },
  props: {
    coupon: {
      type: Object,
      default: () => null
    },
    /**
     * 优惠券弹窗
     */
    isCouponPopup: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isFirst: true,
      cartInfo: null,
      remarkConetnt: '', // 弹窗里面的备注
      isPresellPopup: false, // 预售说明弹窗
      isRemarkPopup: false, // 备注弹窗
      isInvoicePopup: false, // 发票弹窗
      activeIndex: 0,
      coupons: this.coupon,
      couponText: '',
      countLimit: '200/200',
      invoicesInfo: '',
      couponActiveIndex: 'usable',
      remark: '' // 购物车备注

    }
  },

  computed: {
    ...mapGetters(['getSelectIdents', 'getReceiverAddress']),
    theme () {
      return getTheme()
    },
    getCouponImg () {
      return item => {
        if (+item.coupon_type === 1) {
          return 'url(' + require(`@/assets/img/coupon/coupon_red.png`) + ')'
        } else {
          return 'url(' + require(`@/assets/img/coupon/coupon_blue.png`) + ')'
        }
      }
    },
    getAddres () {
      return this.getReceiverAddress
    },
    isPresell () {
      return this.$route.path === '/shopping-cart/presell'
    }

  },

  watch: {
    coupon: {
      deep: true,
      immediate: true,
      handler (value) {
        this.coupons = value
        let text = ''
        if (value.usable.length > 0) {
          let num = 0
          value.usable.forEach(item => {
            if (+item.state === 3) {
              num += 1
            }
          })
          if (num > 0) {
            text = `已选${num}张`
          } else {
            text = `有${value.usable.length}张优惠券`
          }
        } else {
          text = '无可用优惠券'
        }
        this.couponText = text
      }
    },
    remark: {
      deep: true,
      immediate: true,
      handler (value) {
        this.$emit('updateRemark', value)
      }
    },
    'cartInfo.points_open' () {
      if (!this.isFirst) {
        this.$emit('loadCartData', true)
      } else {
        this.isFirst = false
      }
    }
  },

  activated () {
    this.loadCartBaseData()
  },

  methods: {
    ...mapActions(['SELECT_IDENTS', 'RECEIVER_ADDRESS']),
    openInvoicePopup () {
      const type = +this.cartInfo.invoices.type
      if (type === 1) {
        this.activeIndex = 2
      } else if (type === 2) {
        this.activeIndex = 1
      } else {
        this.activeIndex = 0
      }
      this.isInvoicePopup = true
    },
    /**
     * @description 加载头部基础信息
     */
    async loadCartBaseData () {
      let { status, data } = await loadCartIndex()
      if (status === ResultCode.SUCCESS) {
        this.cartInfo = data.cart_info
        this.cartInfo.points_open = false
        this.activeIndex = invoiceType[this.cartInfo.invoices.type]
        this.$emit('getCartInfo', data.cart_info)
        this.getInvoices()
        // 首次把地址存到vuex
        if (!this.getReceiverAddress || Array.isArray(this.getReceiverAddress)) {
          this.RECEIVER_ADDRESS(this.cartInfo.address)
        }
        // 未设置支付方式
        if (+this.cartInfo.is_set_payment !== 1) {
          Dialog.alert({
            title: '',
            message: '卖家未设置任何支付方式，请联系客服'
          }).then(() => {
            Dialog.close()
            // on close
          })
        }
      }
    },
    getInvoices () {
      const { cartInfo } = this
      let info
      if (cartInfo && cartInfo.invoices.type) {
        if (+cartInfo.invoices.type === 1) {
          info = `专用发票(${cartInfo.invoices.company_name})`
        } else {
          info = `普通发票(${cartInfo.invoices.company_name})`
        }
      } else {
        info = '不开发票'
      }
      this.invoicesInfo = info
    },
    toAddressList () {
      if (Array.isArray(this.cartInfo.address)) {
        SessionStorage.setItem('newAddress', '1')
        this.$router.replace(`/receiver-address/add`)
        return
      }
      this.$router.replace(`/receiver-address?path=` + this.$route.fullPath)
    },
    /**
     * @description 打开备注弹窗
     */
    openRemarkPopup () {
      this.isRemarkPopup = true
      this.remarkConetnt = this.remark
    },
    selectCoupon (item) {
      if (item.state < 2) {
        return false
      }
      this.toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner'
      })
      // this.coupons.usable.forEach(item => {
      //   item.isSelect = false
      // })
      this.$emit('selectCoupon', item.get_id)
    },
    /**
     * @description 确认备注
     */
    remarkHandler () {
      this.isRemarkPopup = false
      this.remark = this.remarkConetnt
    },
    remarkInput () {
      const { msg, value } = wordCountLimit(this.remarkConetnt)
      this.remarkConetnt = value
      this.countLimit = msg
    },
    /**
     * @description 更新发票
     */
    async postInvoice () {
      let form = this.cartInfo.invoices
      const validateObj = Object.create(null)
      if (this.activeIndex === 1) {
        Object.assign(validateObj, {
          company_name: '请填写公司名称',
          taxpayer_number: '请填写纳税人识别号'
        })
      }
      if (this.activeIndex === 2) { // 如果选择专用发票
        Object.assign(validateObj, {
          taxpayer_regisaddress: '请填写注册地址',
          tel: '请填写注册电话',
          deposit_bank: '请填写开户银行',
          bank_account: '请填写银行账号' })
      }
      for (let i in validateObj) {
        if (!form[i]) {
          Toast(validateObj[i])
          return
        }
      }

      const params = {
        invoice_tel: form.tel,
        invoice_type: invoiceType[this.activeIndex],
        taxpayer_number: form.taxpayer_number,
        invoice_company: form.company_name,
        deposit_bank: form.deposit_bank,
        bank_account: form.bank_account,
        invoicbank_account_tel: form.bank_account,
        taxpayer_regisaddress: form.taxpayer_regisaddress
      }
      if (this.activeIndex === 0) {
        this.cartInfo.invoices.type = 0
        this.isInvoicePopup = false
        this.getInvoices()
        return
      }
      let { status, info } = await postInvoice(params)
      if (status === ResultCode.SUCCESS) {
        Toast('操作成功')
        this.loadCartBaseData()
        this.isInvoicePopup = false
      } else {
        Toast(info.msg)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.wrap{
  &-address{
    width: 100%;
    max-height: 90px;
    background:rgba(255,255,255,1);
    border-radius:10px 10px 2px 1px;
    box-sizing: border-box;
    padding: 13px 13px;
    position: relative;
    z-index: 10;
    display: flex;
    &-icon{
      img{
        display: inline-block;
        width: 14px;
        height: 18px;
        margin-top: 2px;
      }
    }
    &-text{
      flex: 1;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 15px;
    }
    &-info{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 15px;
      .company{
        font-size: 14px;
        height: 18px;
        @include ell();
      }
      .contact{
        font-size: 13px;
        color: #555555;
      }
      .address{
        font-size: 12px;
        color: #777777;
        @include ell();
      }
      p{
        padding: 2px 0;
      }
    }
    &-enter{
      @include center();
      /deep/{
        .van-icon-arrow{
          color: #D2D2D2;
        }
      }
    }
  }
  &-info{
    margin-top: 5px;
    margin-bottom: 10px;
    border-radius:0px 0px 10px 10px;
    overflow: hidden;
    /deep/{
      .van-cell:not(:last-child)::after{
        border-bottom: none;
      }
      .van-cell__right-icon{
        color: #D2D2D2;
      }
      .van-cell{
        padding: 10px 10px;
      }
    }
    &-title{
      font-size: 12px;
      color: #333333;
    }
    &-value{
      color: #555555;
      font-size: 12px;
      >span{
        display: block;
        @include ell();
      }
    }
    .remark{
      overflow: hidden;
      box-sizing: border-box;
      padding: 10px 10px;
      font-size: 12px;
      color: #333333;
      display: flex;
      div{
        width: 30px;
      }
      &-content{
        margin-left: 30px;
        flex: 1;
        overflow: hidden;
      }

    }
  }
  .integral{
    height: 45px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      font-size: 12px;
      color: #333333;
    }
  }
}
/*备注*/
.remark-popup{
  /* width: 100%; */
  margin: 10px;
  box-sizing: border-box;
  position: relative;
  background:rgba(247,246,246,1);
  padding: 15px 10px;
  textarea{
    width: 100%;
    height: 134px;
    resize:none;
    border: none;
    outline: none;
    border-radius: 10px 10px 0 0;
    background:rgba(247,246,246,1);
    font-size: 12px;
    box-sizing: border-box;
  }
  .remark-count{
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: #333333;
    font-size: 12px;
  }
}
.invoice-popup{
  margin: 14px 10px;
  .invoice-title{
    font-size: 13px;
    color: #333333;
  }
  .invoice-type{
    margin-top: 13px;
    display: flex;
    &-item{
      padding: 0 18px;
      height: 30px;
      background:rgba(238,238,238,1);
      border-radius: 15px;
      color: #777777;
      font-size: 12px;
      @include center();
      margin-right: 20px;
    }
    .active{
      border: 1px solid var(--APP_theme_color);
      color: var(--APP_theme_color);
      background: var(--APP_theme_color_colorOpacity1);
    }
  }
}
.invoice-form{
  /deep/{
    .van-cell:not(:last-child)::after{
      border: none;
    }
    .van-field__label{
      color: #999999;
      font-size: 12px;
    }
    .van-field__control{
      color: #333333;
      font-size: 14px;
    }
  }
}
/**优惠券 */
.coupon-popup{
  .coupon-type{
    padding-top: 15px;
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: space-around;
    background: #FFFFFF;
    padding-bottom: 15px;
    &-item{
      color: #555555;
      font-size: 12px;
    }
    .active{
      color:#333333;
      position: relative;
      font-weight: 600;
      &::after{
        content: '';
        display: inline-block;
        background: var(--APP_theme_color);
        border-radius: 2px;
        width: 33px;
        height: 2px;
        position: absolute;
        right: 0;
        left: 0;
        margin: auto;
        bottom: -4px;
      }
    }
  }
  /**优惠券 */
  .coupon-list{
    width: 100%;
    &-item{
      margin: 10px;
      height: 90px;
      display: flex;
      &-left{
        width: 115px;
        height: 100%;
        /* background-image: url('~@/assets/img/coupon.png'); */
        background-size: 100%;
        color: #FFFFFF;
        text-align: center;
        .money{
          font-size: 20px;
        }
      }
      &-right{
        flex: 1;
        height: 100%;
        box-shadow:4px 4px 9px 0px rgba(242,242,242,.8), 1px -5px 9px 0px rgba(242,242,242,.34);
        background:rgba(255,255,255,1);
        border-radius:0px 3px 3px 0px;
        box-sizing: border-box;
        padding: 0 20px 0 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .coupon-info{
          box-sizing: border-box;
          padding: 20px 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          &-name{
            color: #333333;
            font-size: 12px;
          }
          &-time{
            color:#999999;
            font-size: 12px;
          }
        }
        /deep/{
          .van-checkbox__icon--disabled .van-icon{
            border: 0.01rem solid #e5e5e5;
            background: none;
          }
        }
      }
    }
  }
}
.remark-content{
  white-space: nowrap;
  &:empty:before{
      content: attr(placeholder);
      color:#999999;
      color: 12px;
  }
  &:focus:before{
      content:none;
  }
}
</style>
